// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"69f24beb","239":"d70063ab","453":"678d0346","455":"bc332f7a"}[chunkId] + ".chunk.js";
};